import {
    AudioLoader,
    AudioListener,
    Audio,
    PositionalAudio,
    BoxGeometry,
    MeshBasicMaterial,
    Mesh,
} from 'three'
import { PositionalAudioHelper } from 'three/addons/helpers/PositionalAudioHelper.js';

import { gsap } from 'gsap'


// ------------------------------------------------------------
// v1.5 - 11/07/23: Included positional audio.


export class SoundController {

    #_initialized = false
    #_muted = false

    #_DOMelem

    #_loader = new AudioLoader()
    #_listener = undefined
    #_buffers = { }
    #_sounds = { }

    #_camera

    constructor(camera) {
        this.#_camera = camera
        this.#_DOMelem = document.querySelector('.UI-sound')
    }

    //

    load(fileNamesArray) {

        const path = './assets/sounds/'
        const loadControl = window.loadControl

        for( let i = 0; i < fileNamesArray.length; i++) {

            const fileName = fileNamesArray[i]
            this.#_buffers[fileName] = new Promise( resolve => {
                this.#_loader.load(`${path}${fileName}.mp3`,
                    (buffer) => {
                        resolve(buffer)
                    },
                    (xhr) => {
                        loadControl.elements['sound_' + fileName] = { loaded: xhr.loaded, total: xhr.total }
                        if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`Sound "${fileName}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                    },
                    (error) => {
                        console.warn(`Error loading `)
                    }
                )
            })
        }

    }

    init() {
        if (this.#_initialized) return

        this.#_listener = new AudioListener()
        this.#_camera.add(this.#_listener)

        this.#_DOMelem.addEventListener('pointerup', () => { this.toggleMute() } )
        this.#_DOMelem.classList.remove('disabled')
        if(sessionStorage.getItem('soundMuted') === 'true') this.toggleMute('true')

        this.#_initialized = true
    }

    async play(name, loop, volume, delay) {

        if ( !this.#_initialized ) {
            console.warn(`SoundController not initialized, Audio: '${name}'`)
            return
        }

        if(!this.#_sounds[name]) {
            const sound = new Audio( this.#_listener )
            sound.setBuffer( await this.#_buffers[name] )

            this.#_sounds[name] = sound
        }

        //
        const sound = this.#_sounds[name]

        if(sound.isPlaying) sound.stop()
        sound.currentTime = 0

        sound.setLoop( loop )
        sound.setVolume( volume )
        
        // Delay in seconds
        if(delay) {
            sound.play(delay)
        } else {
            sound.play()
        }
    }

    async initPositional(name, loop, volume, mesh, refDistance, rollof) {

        // refDistance: Distance to start vanish
        // rollof: Velocity/factor of vanish
        

        if ( !this.#_initialized ) {
            console.warn(`SoundController not initialized, Positional: '${name}'`)
            return
        }

        if(!this.#_sounds[name]) {
            const sound = new PositionalAudio( this.#_listener )
            sound.setBuffer( await this.#_buffers[name] )
            this.#_sounds[name] = sound
        }

        //
        const sound = this.#_sounds[name]

        if(sound.isPlaying) sound.stop()
        sound.currentTime = 0
        
        sound.setLoop( loop )
        sound.setVolume( volume )
        sound.setRefDistance( refDistance )
        sound.setRolloffFactor( rollof )

        // Object
        mesh.add( sound )

        // Helper
        // sound.add( new PositionalAudioHelper(sound) )

        //
        sound.play()
    }

    toggleMute(value) {

        const listener = this.#_listener

        const g = (init, final) => {
            let t = gsap.to( {x: init}, {
                x: final,
                duration: 0.5,
                onUpdate() {
                    listener.setMasterVolume( this.targets()[0].x )
                },
                onComplete() {
                    t = null
                }
            })
        }

        if(!value) {
            if (this.#_muted) {
                g(0,1)
                this.#_muted = false 
                this.#_DOMelem.classList.remove('muted')
                sessionStorage.setItem('soundMuted', 'false')
            } else {
                g(1,0)
                this.#_muted = true
                this.#_DOMelem.classList.add('muted')
                sessionStorage.setItem('soundMuted', 'true')
            }
        } else {
            listener.setMasterVolume( 0 )
            this.#_muted = true
            this.#_DOMelem.classList.add('muted')
        }
    }
}